<template>
  <div>
    <!-- el-tabs 多标签页 v-event.test='`_error(a,b)`' v-event:tab-click:@test -->
    <span v-once :x='$nextTick(v=>Data.currentTab="1")'></span>
    <el-tabs
        type="border-card"
        v-model='Data.currentTab'
        v-s.height='H-74'
        tab-click='$trigger(Data.currentTab)'
        @tab-remove="(tab)=>{
          editableTabs.splice(tab-2);
          Data.currentTab = --tab + '';
        }" >

        <el-tab-pane label="一级分类" name='1' >

          <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
              <el-input
                v-model="Data.inputText"
                placeholder="请输入一级分类名称"

                clearable
                size='small'
                style="max-width:380px;" />
              <el-button
                @click='enter(Data.inputText)'
                
                type="primary"
                icon='el-icon-search'
                size='small'
                style='margin-left:10px;' >搜索</el-button>
            </el-col>
            <el-col :span="6">
              <el-button v-if='addBusinessClass'
                @click="$form('addBusinessClass')"
                size='small'
                type="primary"
                style="float:right;margin-right:10px;"
                icon='el-icon-circle-plus' >添加一级分类</el-button>

              <!-- <el-button
                @click="$form('addAuth')"
                size='small'
                type="primary"
                style="float:right;margin-right:10px;"
                icon='el-icon-delete' >批量删除</el-button> -->
            </el-col>
          </el-row>

          <!-- section 包裹了两个组件: el-table 表格 + el-pagination分页 它们两个通常是不可分割的整体, 一块加上 -->
          <mytable
            :tree="{children: 'children'}"
            :tableColums='tableColums'
            api='getBusinessClassList::bcId'
            updateapi='updateBusinessClass'
            :height="H-230">
          </mytable>

        </el-tab-pane>

        <el-tab-pane
          v-for="(item,index) in editableTabs"
          :key="item.name"
          :label="item.parent + ' - ' + item.title"
          :name="item.name"
          :lazy=true :closable=true
          >

          <el-row style="margin-bottom:10px;">

            <el-col :span="18" class='flex'>
              <el-input
                v-model="item.inputText"
                placeholder="请输入二级分类名称"

                clearable
                size='small'
                style="max-width:380px;" />

              <el-button
                @click='enter(item.inputText)'

                type="primary"
                icon='el-icon-search'
                size='small'
                style='margin-left:10px;'
                >搜索</el-button>
              <!--@click="item.name == 'updateSecondClass' ?  queryClassByParent() : queryThirdByParent() "-->
            </el-col>

            <el-col :span="6">
              <el-button v-if='addBusinessClass'
                @click="$form('addBusinessClass')"

                size='small'
                type="primary"
                style="float:right"
                icon='el-icon-circle-plus'>
                添加{{ item.title }}
              </el-button>
            </el-col>

          </el-row>

          <mytable
            :tableColums='tableColums'
            api='getBusinessClassList::bcId'
            :data="'getBusinessClassList'+(index+2)"
            updateapi='updateBusinessClass'
            :height="H-230"
            >
          </mytable>

        </el-tab-pane>

      </el-tabs>

      <myform
        :viewobj='{
          addBusinessClass:    [ "新增分类", "el-icon-circle-plus" ],
          updateBusinessClass: [ "修改分类", "el-icon-edit-outline"],
          $succeed$: ()=>getBusinessClassList({ $id$: Data.currentTab, dtLevel: +Data.currentTab })
        }'
        @opened="
          arguments.row = $this['$'+Data.currentTab]||{bcId:0};
          arguments[0].title = '新增' + oPlus[Data.currentTab] + ( Data.currentTab !== '1' ? ' | @' + arguments.row.bcName : '' );
          Myformdata.with({
            bcParentId: arguments.row.bcId
          });
        " >
        <hide slot='bcParentId' />
      </myform>
    
    </div>
</template>

<script>
//import func from '../../../vue-temp/vue-editor-bridge';
/*
  样例说明：
  1）所有接口支持链式调用，如 addUser('正在添加..').queryUser("正在查询..")
*/
export default {
  data() {
    return {
      Userinfo:{},
      theDepartment:{},
      muldel1: false,
      muldel2: false,
      muldel3: false,
      oPlus: ['','一级分类','二级分类','三级分类'], // '区级战队','网格'
      editableTabs: [ ],
      row:{},

      /* 在这里 动态渲染你的 tableColums表格列, 哪一列不需要, [!注释掉 或 删除掉!] 即可 ; 还可以在这里 [!增改!] 列 */
      tableColums: {
        $selection: false,

        bcName : ["分类名称"], 

        createtime: [ "创建时间", 200 ],

        $operation: ( this.updateBusinessClass || this.deleteBusinessClass ) && [
          "操作", 250,

          this.updateBusinessClass && `@text: 编辑#warn
           @click: $form( 'updateBusinessClass', $row )
          `,

          this.deleteBusinessClass && `@text: 删除#danger
           @click: _confirm('确定要删除该分类吗?')
                  .trigger( 'deleteBusinessClass', {bcId:$row.bcId} )
                  .trigger( 'getBusinessClassList', { $id$: Data.currentTab } )
          `,

          `@text: {{ oPlus[+Data.currentTab+1] ? '查看' + oPlus[+Data.currentTab+1] : '' }}#success
           @click:
              let find, index, title = oPlus[index = + Data.currentTab + 1 + ''];
              
              editableTabs.length === 0 || void null === ( find = editableTabs.find(v=>v.name === index) )
              ? editableTabs.push({ name: index, title: title, parent: $row.bcName })
              : ( find.title = title, find.parent = $row.bcName );

              $this['$'+index] = $row;
              getBusinessClassList({ $id$: index, bcParentId: $row.bcId })(v=>Data.currentTab = index);
          `,
        ],

      },
    };
  },

  methods: {
    enter(input='') {
      const dtLevel = this.Data.currentTab * 1;
      this.getBusinessClassList({ $id$: dtLevel, bcName: input });
    },
  },

  created() {
    /* 在这里调用初始化接口 或者 执行你自己的数据存储和逻辑 */
    // this.$1 = { authType: 0, authId: 0, authParentId: 0, authName: '' };
    this.Userinfo=$Parse(localStorage.getItem( "$Userinfo"));
    this.theDepartment=this.Userinfo.department;
    // this.getBusinessClassList({ $id$: 3, dtLevel: this.theDepartment.dtLevel,bcParentId:this.theDepartment.bcParentId });
    this.getBusinessClassList({ $id$: 1, bcParentId: 0 });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/bussinessClassify.vue